import { render, staticRenderFns } from "./mechanism_form_step.vue?vue&type=template&id=1a31bc31&"
import script from "./mechanism_form_step.vue?vue&type=script&lang=js&"
export * from "./mechanism_form_step.vue?vue&type=script&lang=js&"
import style0 from "./mechanism_form_step.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports